import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PokerCardIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.35307 1.00796C7.8194 0.940782 7.33067 1.30622 7.26145 1.82418L6.0082 11.2027C5.93899 11.7207 6.3155 12.195 6.84917 12.2622L12.6469 12.992C13.1806 13.0592 13.6693 12.6938 13.7385 12.1758L14.9918 2.79727C15.061 2.27931 14.6845 1.80496 14.1508 1.73778L8.35307 1.00796ZM8.94746 6.46028L10.8413 4.52422C10.888 4.47657 10.9673 4.48701 11 4.5451L12.3283 6.90532C12.3501 6.94405 12.3437 6.99252 12.3126 7.02429L10.4188 8.96035C10.3721 9.00801 10.2928 8.99756 10.2601 8.93947L8.9318 6.57925C8.91 6.54052 8.91638 6.49205 8.94746 6.46028Z"
		></path>
		<path
			fill="currentColor"
			d="M4.72462 12.1824L5.78251 3L1.56112 4.79638C1.11286 4.98712 0.886844 5.55083 1.05629 6.05545L3.84758 14.3683C4.01703 14.8729 4.51777 15.1274 4.96602 14.9366L8 13.6456L5.4735 13.2767C4.99827 13.2073 4.66299 12.7173 4.72462 12.1824Z"
		></path>
	</svg>
))
